<template>
  <v-card v-if="currentPreference !== null" class="pa-5 text-center" style="border-radius: 25px;" outlined>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-img :src="test.fundingEvaluation.fundingVendor.logoUrl" max-height="25" class="mb-5" position="center center" contain/>
          <h2>{{ $t('title', { market: currentPreference.title }) }}</h2>
          <h1>{{ test.fundingEvaluation.fundingVendor.name }}</h1>
          <v-row align="center" justify="center">
            <CircularChart v-if="stringDataBalance !== null" :height="250" :primary-color="'#00a553'"
                           :secondary-color="'#575b64'" :string-data="stringDataBalance" :series="seriesBalance"/>
          </v-row>
          <v-btn class="btn-details px-7" @click="seeDetails">{{ $t('btnSeeDetails') }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import CircularChart from "@/views/Funding/Simulation/components/CircularChart";
export default {
  name: "SummaryTest",
  components: {CircularChart},
  props: {
    market: String,
    test: Object,
  },
  data() {
    return {
      preferences: [
        { market: 'Forex', iconUrl: 'https://swiset.com/wp-content/uploads/2021/09/Swiset-Forex-Simulation.svg', title: this.$t('forex.title'),description: this.$t('forex.description') },
        { market: 'Futures', iconUrl: 'https://swiset.com/wp-content/uploads/2021/09/Swiset-Futures-Simulation.svg', title: this.$t('futures.title'), description: this.$t('futures.description') },
      ],
      currentPreference: null,

      // Charts
      stringDataBalance: null,
      chartOptionsBalance: {
        chart: {
          height: 250,
          type: 'radialBar',
        },
        colors: ['#00a553'],
        plotOptions: {
          radialBar: {
            hollow: {
              size: '70%',
            }
          },
        },
        labels: [this.$t('reachedLabel')],
      },
      seriesBalance: [],
    };
  },
  watch: {
    test() {
      this.processPerformance();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.currentPreference = this.preferences.find((data) => data.market === this.market);
      this.processPerformance();
    },
    processPerformance() {
      this.seriesBalance = [];
      let totalProfit = Math.abs(Number(this.test.fundingEvaluation.initialBalance) - Number(this.test.fundingEvaluation.target));
      let reachedProfit =  (Number(this.test.currentProfit) / totalProfit) * 100;
      this.seriesBalance.push(reachedProfit);
      this.stringDataBalance = {
        firstTitle: this.$t('targetTitle'),
        firstNumber: Number(this.test.fundingEvaluation.target) - Number(this.test.fundingEvaluation.initialBalance),
        secondTitle: this.$t('currentProfitTitle'),
        secondNumber: Number(this.test.currentProfit),
      };
    },
    seeDetails() {
      this.$router.push({ name: 'funding-simulation-summary', params: { testId: this.test.id }});
    }
  }
}
</script>

<i18n>
{
  "en": {
    "forex": {
      "title": "Forex"
    },
    "futures": {
      "title": "Futures"
    },
    "title": "Your simulation on {market}",
    "start": "Start",
    "end": "End",
    "daysRemaining": "{days} Remaining Days",
    "targetTitle": "Profit Target",
    "currentProfitTitle": "Current Profit",
    "reachedLabel": "Reached",
    "btnSeeDetails": "See Details"
  },
  "es": {
    "forex": {
      "title": "Forex"
    },
    "futures": {
      "title": "Futuros"
    },
    "title": "Tú simulación en {market}",
    "start": "Inicio",
    "end": "Final",
    "daysRemaining": "{days} Días Restantes",
    "targetTitle": "Rendimiento Objetivo",
    "currentProfitTitle": "Rendimiento Actual",
    "reachedLabel": "Alcanzado",
    "btnSeeDetails": "Ver Detalles"
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";
.btn-details {
  background-color: $black-color !important;
  color: $white-color !important;
}
</style>
